import React from 'react';
import { AnyObject } from 'final-form';

import { createFormField } from 'Shared/utils/createFormField';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';

import './index.scss';

function SelectAll({ value: values, onChange }: AnyObject) {
  const checked = values.length && values.filter(({ disabled }) => !disabled).every(({ selected }) => selected);

  const handleChange = () => onChange(values.map(value => ({ ...value, selected: value.disabled ? false : !checked })));

  return (
    <div className="SelectAll d-flex cursor-pointer" onClick={handleChange} data-test="select-all-checkbox">
      <StyledCheckbox checked={checked} onChange={() => null} />
      <div className="SelectAll__label">Select All</div>
    </div>
  );
}

export default createFormField(SelectAll);
